
export const userInfo = {
    data: {},
    clear() {
        this.data = {};
    },
    setData(data) {
        this.data = data;
    }
}
export const dataStorage = []